import React from 'react';
import {
  OfficialCheckV115,
  OfficialEngravingV115,
  OfficialSealV115,
  OfficialShieldV115,
} from './OfficialSealV115';
import './officialModelsV115.css';

export default function OfficialModelsV115({ checked, onChange, language }) {
  const zh = language?.startsWith('zh');
  const promises = zh
    ? [
        ['零数据采集', ''],
        ['原模型全参，无量化', ''],
        ['官方保密协议', ''],
        ['官方接口直连', '官方 → 平台 → 客户，不经过其他第三方'],
        ['收费合理，支持折扣', '折扣梯度可与平台协商'],
        ['无需代理', '合法合规使用'],
        ['可开发票', ''],
      ]
    : [
        ['Zero data collection', ''],
        ['Full-parameter original models', 'No quantization'],
        ['Official confidentiality agreements', ''],
        [
          'Direct official APIs',
          'Provider → platform → customer, with no other intermediary',
        ],
        [
          'Fair pricing with discounts',
          'Discuss volume discount tiers with the platform',
        ],
        ['No proxy required', 'Use in accordance with applicable requirements'],
        ['Invoices available', ''],
      ];
  return (
    <section
      className={`model-official-band-v115${checked ? ' is-active' : ''}`}
      aria-labelledby='model-official-title-v115'
    >
      {checked && <OfficialEngravingV115 />}
      {checked && (
        <OfficialSealV115 className='model-official-band-seal-v115' />
      )}
      <label
        className='model-official-heading-v115'
        htmlFor='model-official-only-v115'
      >
        <input
          id='model-official-only-v115'
          className='model-official-input-v115'
          type='checkbox'
          role='switch'
          checked={checked}
          aria-checked={checked}
          aria-label={zh ? '仅看官方模型' : 'Official models only'}
          onChange={(event) =>
            onChange(event, { checked: event.target.checked })
          }
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              event.currentTarget.click();
            }
          }}
        />
        <OfficialShieldV115 className='model-official-emblem-v115' />
        <span
          id='model-official-title-v115'
          className='model-official-title-v115'
        >
          {zh ? '官方模型' : 'Official models'}
        </span>
        <span className='model-official-control-v115' aria-hidden='true'>
          <span className='model-official-track-v115' />
          <span>{zh ? '仅看官方模型' : 'Official models only'}</span>
        </span>
        <span className='model-official-focus-v115' aria-hidden='true' />
      </label>
      {checked && (
        <ul className='model-official-promises-v115'>
          {promises.map(([title, detail]) => (
            <li key={title}>
              <OfficialCheckV115 />
              <span>
                <strong>{title}</strong>
                {detail && <span>{detail}</span>}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
